import React, { useContext, useEffect, useState } from 'react';
import { Box, Chip } from '@mui/material';
import { ITitleInternal } from '../../../generated/graphql';
import SearchInput from './SearchInput';
import { AppContext } from '../../../AppContext';
import { Actions } from '../../../enums/ActionEnums';
import ContentGrid from './ContentGrid';
import './index.css';
import SelectAllButton from '../../Common/Buttons/SelectAllButton';

interface IProps {
  data: ITitleInternal[];
}

const ContactTitleStep: React.FunctionComponent<IProps> = ({ data }: IProps) => {
  const { dispatch, state } = useContext(AppContext);
  const [currentTitles, setCurrentTitles] = useState(data);
  const [selectedTitlesIds, setSelectedTitlesIds] = useState<string[]>(
    state.selectedRecipientList?.contactTitleIds || []
  );

  useEffect(() => {
    setCurrentTitles(data);
  }, [data]);

  const handleCheckClicked = (titleId: string) => {
    let titles = [];
    if (selectedTitlesIds.includes(titleId)) {
      titles = selectedTitlesIds.filter((id) => id !== titleId);
      setSelectedTitlesIds(titles);
    } else {
      titles = [titleId, ...selectedTitlesIds];
      setSelectedTitlesIds(titles);
    }
    dispatch({
      type: Actions.SetRecipientListContactTitles,
      payload: {
        contactTitleIds: titles
      }
    });
  };

  const filterValues = (text: string) => {
    const filtered = data.filter((t) => t.name.toLowerCase().includes(text.toLowerCase()));
    setCurrentTitles(filtered);
  };

  const handleAllClicked = () => {
    const titles = data?.map((t) => t.id);
    setSelectedTitlesIds(titles);
    dispatch({
      type: Actions.SetRecipientListContactTitles,
      payload: {
        contactTitleIds: titles
      }
    });
  };

  return (
    <Box className="step-container">
      <Box className="section-header" sx={{ height: '80px', justifyContent: 'space-between' }}>
        <SearchInput
          id={'contact-title-step-search-input'}
          filter={filterValues}
          sx={{ width: '40%' }}
        />
        {selectedTitlesIds.length > 0 ? (
          <Chip
            id={'selected-contact-types-count'}
            data-testid={'selected-contact-types-count'}
            size="small"
            className="header-chip"
            label={`${selectedTitlesIds.length} contact ${
              selectedTitlesIds.length === 1 ? 'title' : 'titles'
            } selected`}
            onDelete={() => {
              setSelectedTitlesIds([]);
              dispatch({
                type: Actions.SetRecipientListContactTitles,
                payload: { contactTitleIds: [] }
              });
            }}
          />
        ) : (
          <SelectAllButton onClick={handleAllClicked} text={`${data.length} contact titles`} />
        )}
      </Box>
      <Box className="step-content-container">
        <ContentGrid
          data={currentTitles}
          clickedValues={selectedTitlesIds}
          handleCheckClicked={handleCheckClicked}
          editable={true}
          staticGrid
        />
      </Box>
    </Box>
  );
};

export default ContactTitleStep;
